import { store } from '@store/online/index';
import config from '../../config/configuration';
import { getCurrentRestaurant } from '../../utils/UtilFunctions';
import { endpoints } from '../core/apiConfig';
import client from '../core/Interceptor';
import { getCookie } from 'cookies-next';

export const getStripeKeys = async () => {
  const token = getCookie('AccessToken') ?? '';
  const response = await fetch(`${config.BASE_URL}${endpoints.checkout.getStripeKey}`, {
    cache: 'no-store',
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.json();
};

export const createIntent = async (obj: object) => {
  const response = await client.post(endpoints.checkout.createIntent, obj);
  return response;
};

export const createIntentV2 = async (obj: object) => {
  const response = await client.post(endpoints.checkout.createIntentV2, obj);
  return response;
};

export const createPayLaterOrder = async (cartId: number | undefined, restaurantId: number | undefined) => {
  const response = await client.post(`${endpoints.cart.createPayLayterOrder}/${cartId}?restaurantId=${restaurantId}`);
  return response;
};

export const findWebhook = async (intentId: number, payLoad: any, businessId?: number, restaurantId?: number) => {
  restaurantId = restaurantId || getCurrentRestaurant().id;
  businessId = businessId || store.getState().restaurant.selectedBusinessId || undefined;
  const response = await client.post(
    `${endpoints.checkout.findWebhook}/${intentId}?restaurantId=${restaurantId}&intentType=${payLoad.intentType}&retryAttempt=${payLoad.retryAttempt}&type=${payLoad.type}`,
    {},
    {
      headers: {
        'x-tenant-id': businessId,
      },
    }
  );
  return response;
};

export const getCheckoutToken = async (data: object, restaurantId: any) => {
  const response = await client.post(`${endpoints.checkout.getCheckoutToken}`, { data, restaurantId });
  return response;
};
